import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dealer-become-partner',
    imports: [],
    templateUrl: './dealer-become-partner.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dealer-become-partner.component.css'
})
export class DealerBecomePartnerComponent {

}
